import {BaseModel} from './base-model';

export class NotificationMinute extends BaseModel {
    Seen: boolean;
    Message: string;
    ExpiredAt: string;
    CreatedAt: string;
    Subject: string;
    Link: string;
}